export interface GPUInit {
  adapter: GPUAdapter;
  device: GPUDevice;
  format: GPUTextureFormat;
}

export async function initWebGPU(): Promise<GPUInit> {
  const adapter = await navigator.gpu.requestAdapter({ powerPreference: 'high-performance' });
  if (!adapter) {
    throw new Error('Failed to get GPU adapter. Your GPU may not support WebGPU.');
  }

  const device = await adapter.requestDevice();
  const format = navigator.gpu.getPreferredCanvasFormat();

  return { adapter, device, format };
}
